import Vue from "vue";

Vue.mixin({
  data() {
    return {
      defaultLanguage: "",
      timeout: null,
    };
  },

  mounted() {
    if (
      this.$application &&
      this.$application.i18n &&
      this.$application.i18n.defaultLocale
    ) {
      this.defaultLanguage = this.$application.i18n.defaultLocale;
    }
  },

  computed: {
    $homepageLink() {
      if (this.$i18n.locale === this.defaultLanguage) {
        return "/";
      } else {
        return `/${this.$i18n.locale}`;
      }
    },
  },

  methods: {
    debounce(callback, delay = 300) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        callback();
      }, delay);
    },

    $returnDateCase(dateString, dateCase) {
      if (!dateString) return;

      const date = new Date(dateString);
      const day = date.getDate();
      const year = date.getFullYear();
      var region = "en-EN";

      if (this.$i18n.locale === "hr") {
        region = "hr-HR";
      }

      switch (dateCase) {
        case "day":
          return day;
        case "month":
          return date.toLocaleString(region, { month: "long" });
        case "year":
          return year;
        default:
          return `${day}.${date.toLocaleString(region, {
            month: "long",
          })} ${year}.`;
      }
    },

    $scrollToTop() {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 200);
    },

    $scrollToElement(element) {
      setTimeout(() => {
        const headerHeight = document.querySelector('.controller-header-bottom')?.offsetHeight || 0;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 200);
    },
  },
});
